/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * LoadPreviousIcon
 */
export default class LoadPreviousIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M13.5 1.571C19.297 1.571 24 6.24 24 12s-4.703 10.429-10.5 10.429c-1.728 0-3.398-.416-4.895-1.2a1 1 0 01.929-1.772 8.515 8.515 0 003.966.972c4.696 0 8.5-3.776 8.5-8.429 0-4.653-3.804-8.429-8.5-8.429-4.566 0-8.29 3.57-8.491 8.046l1.273-1.313A1 1 0 017.8 11.6l-.082.096-3 3.095a1 1 0 01-1.341.087l-.095-.087-3-3.095a1 1 0 011.343-1.477l.093.085 1.288 1.328c.195-5.59 4.82-10.06 10.494-10.06zm-.5 4.19a1 1 0 011 1v5.287h4a1 1 0 010 2h-5a1 1 0 01-1-1V6.762a1 1 0 011-1z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

